const moduleName = 'clients';

module.exports = () => {

	Array.from(document.querySelectorAll('.js-clients')).forEach((self) => {
		if (self.dataset[moduleName + 'Init'] === 'true') return;
		self.dataset[moduleName + 'Init'] = true;

		const clients = self;
		const line = clients.querySelector('.js-clients-line');

		if (!document.body.classList.contains('mobile')) {
			document.addEventListener('mousemove', (event) => {
				const windowWidth = document.documentElement.clientWidth;
				const lineWidth = line.scrollWidth;

				if (windowWidth > lineWidth) return;

				const lineOffset = lineWidth * event.clientX / windowWidth - event.clientX;

				line.style.transform = `translateX(-${lineOffset}px)`;
			});
		}
	});

};